import { ModalImage2 } from "./ModalImage2"

export const ModalPaymentImage = ({ id, code, isOpen, setIsOpen }) => {
  const imageUri = process.env.REACT_APP_URL_PAYMENT_IMAGES + "?id=" + id + "&code=" + code

  return (
    <ModalImage2 imageUri = {imageUri} isOpen={isOpen} setIsOpen={setIsOpen}/>
  )
}
